import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getReferralConfig = id => {
  return http.get(
    `${getBaseUrl()}/referral_config/${id}`
  );
};

export const getReferralConfigs = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/referral_config`
    );
  }
  return http.get(
    `${getBaseUrl()}/referral_config?${paginate}`
  );
};

export const updateReferralConfig = data => {

  return http.put(
    `${getBaseUrl()}/referral_config/${data.id}`,
    data
  );
};
export const submitReferralConfig = data => {

  return http.post(
    `${getBaseUrl()}/referral_config`,
    data
  );
};
